import Vue from 'vue'
import Router from 'vue-router'
import CreateNotification from '@/components/CreateNotification'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/colgate/createnotification',
      name: 'CreateNotification',
      component: CreateNotification
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js